import axios from 'axios';
import { getStoredToken, isTokenValid, removeToken } from '../utils/Auth';

export const adminApiPrefix = '/admin-api';
export const apiPrefix = '/api';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((request) => {
  const token = getStoredToken();
  if (token) {
    if (isTokenValid()) {
      request.headers.set('Authorization', `Bearer ${token}`);
    } else {
      removeToken();
    }
  }

  return request;
});

api.interceptors.response.use(
  (response) => response,
  async (err) => {
    if (err?.response?.data?.error) {
      throw new Error(err.response.data.error);
    }

    throw new Error('Unknown API error.');
  },
);

export default api;
